<template>
  <div>
    <b-form-group label="Nome" label-for="input-name">
      <b-form-input
        type="text"
        id="input-name"
        placeholder="Informe o nome da rota"
        v-model="route.name"
      />
    </b-form-group>

    <b-form-group label="País" label-for="input-documento">
      <b-form-select
        v-model="route.originCountryId"
        :options="countryOpt"
        @change="getAllStates(route.originCountryId)"
      ></b-form-select>
    </b-form-group>
    <b-form-group label="Estado" label-for="input-documento">
      <b-form-select
        v-model="route.originStateId"
        :options="stateOpt"
        @change="getAllCities(route.originStateId)"
        :disabled="disableState"
      ></b-form-select>
    </b-form-group>
    <b-form-group label="Cidade" label-for="input-documento">
      <b-form-select
        v-model="route.originCityId"
        :options="cityOpt"
        :disabled="disableCity"
      ></b-form-select>
    </b-form-group>
    <b-form-group label="País" label-for="input-documento">
      <b-form-select
        v-model="route.destinationCountryId"
        :options="countryOpt"
        @change="getAllStates(route.destinationCountryId)"
      ></b-form-select>
    </b-form-group>
    <b-form-group label="Estado" label-for="input-documento">
      <b-form-select
        v-model="route.destinationStateId"
        :options="stateOpt"
        @change="getAllCities(route.destinationStateId)"
        :disabled="disableState"
      ></b-form-select>
    </b-form-group>
    <b-form-group label="Cidade" label-for="input-documento">
      <b-form-select
        v-model="route.destinationCityId"
        :options="cityOpt"
        :disabled="disableCity"
      ></b-form-select>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "RoutesCrud",
  props: {
    route: Object,
  },
  data() {
    return {
      countryOpt: [],
      stateOpt: [{ value: null, text: "Selecione um país" }],
      cityOpt: [{ value: null, text: "Selecione um estado" }],
    };
  },
  methods: {
    getAllCountries() {
      this.$apiScheduler
        .get("/system/country")
        .then((response) => {
          this.countryOpt = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllStates(country) {
      this.$apiScheduler
        .get("/system/state/" + country)
        .then((response) => {
          this.stateOpt = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllCities(state) {
      this.$apiScheduler
        .get("/system/city/" + state)
        .then((response) => {
          this.cityOpt = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    // Your computed properties here
  },
  mounted() {
    this.getAllCountries();
  },
};
</script>
